import keyboardKeys from '../constants/keyboardKeys';
const { ENTER, SPACE, ARROW_LEFT, ARROW_RIGHT, ESCAPE } = keyboardKeys;

export function isEnterOrSpace(key: string): boolean {
  return [ENTER, SPACE].includes(key as any); // Overrides TS as the check is explicit
}

export function isRightOrLeftArrow(key: string): boolean {
  return [ARROW_RIGHT, ARROW_LEFT].includes(key as any);
}

function isKey(key: string, keyName: string): boolean {
  return key === keyName;
}

export function isEscape(key: string): boolean {
  return isKey(key, ESCAPE);
}

export function isEnter(key: string): boolean {
  return isKey(key, ENTER);
}

export function isArrowUp(key: string): boolean {
  return isKey(key, 'ArrowUp');
}
export function isArrowDown(key: string): boolean {
  return isKey(key, 'ArrowDown');
}

export default {
  isEnterOrSpace,
  isRightOrLeftArrow,
  isEscape,
  isEnter,
  isArrowUp,
  isArrowDown,
};
